import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers/rootReducer';

// Create a logger instance with useful defaults
const logger = createLogger({
  collapsed: true,
  duration: true,
  timestamp: true,
  logErrors: true,
});

// Configure the store with a single instance
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(process.env.NODE_ENV !== 'production' ? [logger] : []),
  devTools: process.env.NODE_ENV !== 'production' ? {
    name: 'knockthedoor Web App',
    trace: true,
    traceLimit: 25,
    actionsDenylist: [],
    actionsBlacklist: [],
    serialize: {
      options: {
        map: true,
        set: true,
        date: true,
        undefined: true,
        error: true,
        function: (fn) => `fn(${fn.name || 'anonymous'})`,
      },
    },
  } : false,
});

// Handle hot module replacement in development
if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./reducers/rootReducer', () => {
    const newRootReducer = require('./reducers/rootReducer').default;
    store.replaceReducer(newRootReducer);
  });
}

// Export a function to get the store instance
export function getStore() {
  return store;
}

export default store;